import axios from 'axios';
import { firebaseAuth } from '../contexts/AuthContext';
import config from '../config';

const http = axios.create({
    baseURL: config.baseURI,
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 0
});

/**
 * HTTP request interceptor.
 */
http.interceptors.request.use(async (config) => {
    const { token } = await firebaseAuth.currentUser.getIdTokenResult();

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

export default http;
